import { useTheme } from "../theme/ThemeContext";

const Foglia = ({ className, dark }) => (
  <svg viewBox="0 0 64 64" className={className} aria-label="Gusto y Ciencia">
    <rect x="4" y="4" width="56" height="56" rx="18" className={dark ? "fill-linen" : "fill-pine"} />
    <path d="M32 45c-7.5-3.6-11-9.5-11-16 6.5 1 10.5 4 11 8 .5-4 4.5-7 11-8 0 6.5-3.5 12.4-11 16z" className={dark ? "fill-pine-dark" : "fill-linen"} />
    <circle cx="43" cy="21" r="4" className="fill-clay" />
  </svg>
);

const Intersezione = ({ className, dark }) => (
  <svg viewBox="0 0 64 64" className={className} aria-label="Gusto y Ciencia">
    <circle cx="25" cy="32" r="18" className={dark ? "fill-linen" : "fill-pine"} />
    <circle cx="39" cy="32" r="18" fill="none" strokeWidth="3" className={dark ? "stroke-linen" : "stroke-pine"} />
    <path d="M32 15.42A18 18 0 0 1 32 48.58A18 18 0 0 1 32 15.42Z" className="fill-clay" />
  </svg>
);

const Germoglio = ({ className, dark }) => (
  <svg viewBox="0 0 64 64" className={className} aria-label="Gusto y Ciencia">
    <path d="M13 38a19 19 0 0 0 38 0" fill="none" strokeWidth="3.5" strokeLinecap="round" className={dark ? "stroke-linen" : "stroke-pine"} />
    <path d="M32 38V21" fill="none" strokeWidth="3.5" strokeLinecap="round" className={dark ? "stroke-linen" : "stroke-pine"} />
    <path d="M32 30c-9 0-14-5-14-12 7 0 14 5 14 12z" className={dark ? "fill-linen" : "fill-pine"} />
    <path d="M32 22c0-8 6-13 14-13 0 8-6 13-14 13z" className="fill-clay" />
  </svg>
);

const Monogramma = ({ className, dark }) => (
  <svg viewBox="0 0 64 64" className={className} aria-label="Gusto y Ciencia">
    <path d="M50.8 38.8A20 20 0 1 1 47.3 19.1" fill="none" strokeWidth="7" strokeLinecap="round" className={dark ? "stroke-linen" : "stroke-pine"} />
    <path d="M34 36.5h17" fill="none" strokeWidth="7" strokeLinecap="round" className={dark ? "stroke-linen" : "stroke-pine"} />
    <circle cx="47.3" cy="19.1" r="5.5" className="fill-clay" />
  </svg>
);

export const LOGO_VARIANTS = [
  { id: "foglia", name: "Foglia", desc: "Squircle con foglia astratta (gusto) e punto (molecola, scienza).", Component: Foglia },
  { id: "intersezione", name: "Intersezione", desc: "Scelta definitiva. Due cerchi che si incontrano: dove gusto e scienza si sovrappongono nasce il metodo.", Component: Intersezione },
  { id: "germoglio", name: "Germoglio", desc: "Un germoglio che cresce da una ciotola/piastra: crescita, cura, cibo vivo.", Component: Germoglio },
  { id: "monogramma", name: "Monogramma G", desc: "La G di Gusto e Giada come anello aperto con un nodo molecolare.", Component: Monogramma },
];

export const Logo = ({ className = "h-10 w-10", dark = false }) => {
  const { logo } = useTheme();
  const variant = LOGO_VARIANTS.find((v) => v.id === logo) || LOGO_VARIANTS[0];
  return <variant.Component className={className} dark={dark} />;
};
